<template>
  <v-expansion-panel style="margin-top: 30px" :id="id" @change="panelFocus()">
    <v-expansion-panel-header class="v-card__title">
      <v-icon
        v-if="icon"
        class="v-card-icon"
        dark
        :style="{
          'background-color':
            color !== '' ? color : $vuetify.theme.currentTheme.primary,
        }"
      >
        {{ icon }}
      </v-icon>
      <div class="row no-gutters">
        <div class="col">
          <h4 v-if="title">{{ title }}</h4>
        </div>
      </div>
      <!-- <div v-if="$slots.title" style="margin-left:80px">
        <slot name="title" />
      </div> -->
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-divider v-if="title" class="mx-3" />
      <slot />
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  props: ["color", "icon", "title"],
  data() {
    return {
      id: undefined,
    };
  },
  mounted() {
    this.id = Math.random().toString();
  },
  methods: {
    panelFocus() {
      // console.log(this.id);
      let panel = document.getElementById(this.id);
      if (panel.ariaExpanded === "true") {
        return;
      }
      setTimeout(() => {
        document.getElementById(this.id).scrollIntoView({
          behavior: "smooth",
        });
      }, 450);
    },
  },
};
</script>
<style scoped>
.v-card__title {
  padding-bottom: 2px !important;
  position: relative;
  /* display: block; */
}
.v-card-icon {
  border-radius: 3px;
  padding: 20px;
  top: -14px;
  max-width: 64px;
  left: 15px;
  box-shadow: 0 12px 20px -10px rgba(76, 175, 80, 0.28),
    0 4px 20px 0 rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(76, 175, 80, 0.2);
  position: absolute;
  z-index: 1;
}
.v-card__title h4 {
  color: #3c4858;
  font-weight: 300;
  font-size: 1.125rem;
  padding: 12px 5px 10px 10px;
  padding-left: 90px;
  display: block;
}
.v-application .mx-3 {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.material-card >>> .v-card__text {
  padding: 16px !important;
}
</style>
